import React from 'react';
import classNames from 'classnames';
import TitleTag from '@/components/titletag';
import styles from './index.module.scss';

interface IDataCardProps {
  brandName: string;
  indicatorData: {
    indicatorName: string | React.ReactElement;
    indicatorNum: string | number;
    indicatorUnit?: string;
  }[];
  width?: number;
  className?: string;
}

export default function DataCard({ brandName, indicatorData, width, className }: IDataCardProps) {
  return (
    <div className={classNames(styles.dataCard, className)} style={{ width: width + 'px' }}>
      <TitleTag style={{ marginBottom: '12px', fontSize: '16px' }}>{brandName}</TitleTag>
      {indicatorData?.map((item, index) => (
        <div className={classNames('flex-row-nowrap', 'flex-between-center', styles.dataItem)} key={index}>
          <div>{item?.indicatorName}</div>
          {item?.indicatorNum ? (
            <div className={styles.num}>
              <div className={styles.text}>{item?.indicatorNum}</div>
              {item.indicatorUnit && <div className={styles.unit}>{item?.indicatorUnit}</div>}
            </div>
          ) : (
            <div className={styles.emptyStateText}>暂无数据</div>
          )}
        </div>
      ))}
    </div>
  );
}
